<template>
  <q-dialog :visible.sync="isVisible" title="提示" width="900px" :innerScroll="false" @close="onCancel">
    <div class="prompt-content">
      <div class="warning-message">以下商品的直播价低于对应“达播极限价”，请先进行“特殊直播价申请”后才能导入。</div>

      <el-table stripe border :data="tableData.list" height="30vh" :header-cell-style="{ backgroundColor: '#F4F8FB' }" style="margin-top: 15px" v-loading="loading">
        <el-table-column prop="goodsCode" label="商品编码" min-width="120"></el-table-column>
        <el-table-column prop="goodsName" label="商品名称" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="livePrice" label="直播价" min-width="80" align="center">
          <template slot-scope="{ row }">
            <span style="color: red">{{ row.livePrice }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="liveRebate" label="直播佣金" min-width="80" align="center"></el-table-column>
        <el-table-column prop="settlementPrice10" label="极限价10%" min-width="90" align="center"></el-table-column>
        <el-table-column prop="settlementPrice15" label="极限价15%" min-width="90" align="center"></el-table-column>
        <el-table-column prop="settlementPrice20" label="极限价20%" min-width="90" align="center"></el-table-column>
      </el-table>

      <div style="text-align: right; margin-top: 15px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="tableData.pageNum"
          :page-sizes="[30, 60, 90]"
          :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="tableData.total"
        ></el-pagination>
      </div>
    </div>
    <template v-slot:footer>
      <div class="dialog-footer">
        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="submitting">申请</el-button>
      </div>
      <div class="success-message">申请通过后，系统将自动导入申请价格，无需重复导入</div>
    </template>
  </q-dialog>
</template>

<script>
export default {
  name: 'PromptDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
      taskId: {
        type: [String, Number],
      },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  data() {
    return {
      submitting: false,
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },

    async init() {
      this.loading = true;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: this.taskId,
      };
      this.searchFormData = data;
      this.$q.goods
        .goodsLivePriceImportFailPage({ data: data })
        .then(res => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onSubmit() {
      this.submitting = true;
      this.$q.goods
        .goodsSpecialLivePriceBatchApprove({ fragment: [this.taskId] }) 
        .then(res => {
          this.$message.success('申请成功');
          this.$emit('success');
          this.isVisible = false;
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },

    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
  },
};
</script>

<style lang="stylus" scoped>
.prompt-content {
  padding: 10px 0;
}

.warning-message {
  color: red;
  font-size: 14px;
  text-align: left;
  margin-bottom: 10px;
}

.success-message {
  color: red;
  font-size: 14px;
  text-align: center;
  margin-top: 15px;
}

.dialog-footer {
  text-align: center;
  padding-top: 10px;
}

>>> .el-table th {
  background-color: #F4F8FB !important;
}
</style>
